@if (lockState().active) {
  <section class="fixed inset-0 z-[100] flex min-h-screen flex-col items-center justify-center bg-slate-950/90 px-4 py-8 backdrop-blur-sm">
    <div class="flex w-full max-w-sm flex-col items-center rounded-3xl bg-white px-8 py-10 text-center shadow-xl">
      <img [src]="imageEnum.ALERT_CIRCLE" alt="" class="h-12 w-12" />
      <h1 class="heading mt-4">{{ isTerminal() ? 'Test Terminated' : 'Security check' }}</h1>
      <p class="sub-paragraph mt-3 text-text-secondary">{{ message() }}</p>
      @if (isTerminal()) {
        <div class="mt-6 h-6 w-6 animate-spin rounded-full border-2 border-slate-300 border-t-brand-primary" aria-hidden="true"></div>
        <div class="mt-6 w-full">
          <app-primary-button text="Go to Test Series" (buttonClick)="exitToTestSeries()" />
        </div>
      } @else {
        @if (resumeBlocked()) {
          <p class="sub-paragraph mt-4 text-red-600">Developer tools are still open. Close them (F12) to resume.</p>
        }
        <div class="mt-6 w-full">
          <app-primary-button text="Resume Test" (buttonClick)="resume()" />
        </div>
      }
    </div>
  </section>
}
